import { render, staticRenderFns } from "./update-location-bar.vue?vue&type=template&id=03ca01eb&scoped=true"
import script from "./update-location-bar.vue?vue&type=script&lang=ts"
export * from "./update-location-bar.vue?vue&type=script&lang=ts"
import style0 from "./update-location-bar.vue?vue&type=style&index=0&id=03ca01eb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca01eb",
  null
  
)

export default component.exports